import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { CopyButtonComponent } from '../../../basic/buttons/copy-button/copy-button.component';
import { WorkspaceHolderService } from '../../../core/workspace/workspace.holder.service';
import { WorkspaceService } from '../../../core/workspace/workspace.service';
import { MainSidebarComponent } from '../../../pages/_shared/main-sidebar/main-sidebar.component';
import { BoardIconTitleComponent } from '../../board/board-icon-title/board-icon-title.component';
import { InviteTeamMemberListComponent } from '../../team-member/invite-team-member-list/invite-team-member-list.component';

@Component({
  selector: 'app-workspace-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzStepsModule,
    NzButtonModule,
    NzIconModule,
    NzSkeletonModule,
    NzInputModule,
    NzTableModule,
    NzPopoverModule,
    NzTagModule,

    CopyButtonComponent,
    MainSidebarComponent,
    InviteTeamMemberListComponent,
    BoardIconTitleComponent,
  ],
  templateUrl: './workspace-list.component.html',
  styleUrl: './workspace-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceListComponent {
  workspaceList = toSignal(this.workspaceService.getMyWorkspaceList$(), { initialValue: [] });

  constructor(
    private workspaceService: WorkspaceService,
    private workspaceHolderService: WorkspaceHolderService
  ) {}

  currentWorkspace = computed(() => this.workspaceHolderService.currentWorkspace());
}
